<div class="fixed left-64 top-16 right-0 bottom-7 flex flex-col bg-gradient-to-br from-red-50 to-white z-10">
  <!-- Contenido principal -->
  <div class="flex-1 flex overflow-hidden">
    <!-- Panel izquierdo - Lista de conversaciones -->
    <div class="w-80 bg-white border-r border-red-100 flex flex-col">
      <!-- Buscador -->
      <div class="p-4 border-b border-red-100">
        <div class="relative">
          <svg class="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" placeholder="Buscar conversacion..."
                 class="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-red-500 placeholder-gray-400">
        </div>
      </div>

      <!-- Lista de conversaciones -->
      <div class="flex-1 overflow-y-auto">
        <div *ngIf="conversations.length === 0" class="p-6 text-center text-gray-500">
          <svg class="w-12 h-12 mx-auto mb-3 text-red-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
          </svg>
          <p class="text-sm">No hay conversaciones</p>
        </div>

        <div *ngFor="let conversation of conversations; trackBy: trackByConversation"
             (click)="openChat(conversation)"
             class="px-4 py-3 border-b border-red-50 cursor-pointer transition-all duration-200 hover:bg-red-50 group"
             [ngClass]="{'bg-red-100 border-l-4 border-l-red-500': selectedConversation?.id === conversation.id}">
          <div class="flex items-start gap-3">
            <!-- Avatar -->
            <div class="w-12 h-12 rounded-full flex items-center justify-center text-white font-semibold text-lg flex-shrink-0"
                 [ngClass]="selectedConversation?.id === conversation.id ? 'bg-red-600' : 'bg-red-400'">
              {{ getOtherPersonName(conversation).charAt(0).toUpperCase() }}
            </div>

            <!-- Info -->
            <div class="flex-1 min-w-0">
              <div class="flex items-center justify-between mb-1">
                <h3 class="font-semibold text-gray-900 truncate">{{ getOtherPersonName(conversation) }}</h3>
                <span class="text-xs text-gray-400 flex-shrink-0 ml-2">{{ formatDate(conversation.last_message_date || '') }}</span>
              </div>
              <p class="text-sm text-gray-500 truncate">{{ conversation.last_message || 'Sin mensajes' }}</p>
            </div>

            <!-- Badge y acciones -->
            <div class="flex flex-col items-end gap-1">
              <span *ngIf="conversation.unread_count && conversation.unread_count > 0"
                    class="bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                {{ conversation.unread_count }}
              </span>
              <button *ngIf="canSendMessages()"
                      (click)="deleteConversation(conversation, $event)"
                      class="opacity-0 group-hover:opacity-100 text-red-400 hover:text-red-600 p-1 rounded transition-all"
                      title="Eliminar">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Panel derecho - Chat -->
    <div class="flex-1 flex flex-col bg-gray-50">
      <!-- Estado vacio -->
      <div *ngIf="!showChatModal" class="flex-1 flex items-center justify-center">
        <div class="text-center">
          <div class="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-12 h-12 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
          </div>
          <h3 class="text-xl font-semibold text-gray-800 mb-2">Selecciona una conversacion</h3>
          <p class="text-gray-500">Elige una conversacion de la lista para comenzar</p>
        </div>
      </div>

      <!-- Chat activo -->
      <div *ngIf="showChatModal" class="flex-1 flex flex-col h-full overflow-hidden">
        <!-- Header del chat -->
        <div class="bg-white px-6 py-4 border-b border-red-100 flex items-center justify-between flex-shrink-0 shadow-sm">
          <div class="flex items-center gap-3 h-[42px]">
            <div class="w-11 h-11 bg-red-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
              {{ getChatHeaderName().charAt(0).toUpperCase() }}
            </div>
            <div>
              <h3 class="font-semibold text-gray-900">{{ getChatHeaderName() }}</h3>
            </div>
          </div>
          <button (click)="closeChat()"
                  class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
            <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Area de mensajes -->
        <div #messageContainer class="flex-1 overflow-y-auto p-4 space-y-2">
          <div *ngFor="let message of messages; trackBy: trackByMessage"
               [class]="isMyMessage(message) ? 'flex justify-end' : 'flex justify-start'">
            <div [ngClass]="isMyMessage(message) ? 'msg-sent' : 'msg-received'"
                 class="msg-bubble max-w-[70%]">
              <p class="text-sm leading-relaxed break-words">{{ message.message }}</p>
              <p class="text-[11px] text-right mt-1"
                 [ngClass]="isMyMessage(message) ? 'text-red-200' : 'text-gray-400'">
                {{ formatDate(message.timestamp || '') }}
              </p>
            </div>
          </div>

          <!-- Mensajes vacios -->
          <div *ngIf="messages.length === 0 && !typingUser" class="flex items-center justify-center h-full">
            <div class="text-center text-gray-400">
              <svg class="w-16 h-16 mx-auto mb-3 text-red-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
              <p class="text-sm">Inicia la conversacion</p>
            </div>
          </div>

          <!-- Indicador de escritura estilo WhatsApp -->
          <div *ngIf="typingUser" class="flex justify-start">
            <div class="msg-bubble msg-received">
              <div class="flex items-center gap-1 px-2 py-1">
                <span class="typing-dot"></span>
                <span class="typing-dot"></span>
                <span class="typing-dot"></span>
              </div>
            </div>
          </div>
        </div>

        <!-- Input de mensaje -->
        <div *ngIf="canSendMessages()" class="bg-white px-4 py-3 border-t border-red-100 flex-shrink-0">
          <div class="flex items-center gap-3">
            <input type="text"
                   #messageInput
                   [ngModel]="newMessageText"
                   (ngModelChange)="newMessageText = $event"
                   (input)="onInputChange()"
                   (keyup.enter)="sendMessage()"
                   placeholder="Escribe un mensaje..."
                   class="flex-1 bg-white border border-gray-200 rounded-full px-5 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 placeholder-gray-400">
            <button (click)="sendMessage()"
                    [disabled]="!newMessageText.trim()"
                    class="w-11 h-11 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 shadow-lg hover:shadow-xl">
              <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Mensaje para estudiantes que no pueden enviar -->
        <div *ngIf="!canSendMessages()" class="bg-red-50 px-4 py-3 border-t border-red-100 flex-shrink-0">
          <p class="text-center text-sm text-red-600">Solo los profesores pueden enviar mensajes</p>
        </div>
      </div>
    </div>
  </div>
</div>
